export default __webpack_public_path__ + "static/media/rolamentos.1f16ec45.png";